/// <amd-module name="Artifacts/Maven/commands/Delete" />
import { MavenActions } from "Artifacts/Maven/redux/Actions";
import { getDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createDeleteCommand = getDeleteCommandCreator(MavenActions.softDelete);
